<section class="container-fluid faq" *ngIf="faq?.length">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-3 col-xl-2">
        <h2>FAQ</h2>
      </div>
      <div class="col-12 col-lg-9 col-xl-10">
        <ngb-accordion id="acc" #acc="ngbAccordion" [closeOthers]="true" >
          <ngb-panel id="headingOne">
            <ng-template ngbPanelTitle>
              <span>
                <span>According to the test result, my anxiety level is high. Could this mean that I’m
                  suffering from a disorder?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                The test is not a diagnostic procedure but can detect the probability of you developing
                a disorder. If your test score is high and it is accompanied by problems that bother
                you, we recommend that you see a doctor, psychologist, or psychiatrist.
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="headingtwo">
            <ng-template ngbPanelTitle>
              <span>
                <span>I get different results with each test. Does the test not work?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <p>
                  By taking the test, you will be able to determine the current level of anxiety that
                  you are experiencing. This means that the results may change according to your
                  current state of health.
                <p> If you see a drop in anxiety after engaging in regular physical activity or
                  communicating with a therapist, this is a great sign!</p>
                <p>Anima is a free-view test. Therefore, it is possible to inadvertently or consciously
                  change the results if you adopt a new observation strategy. Try to pass the test
                  without giving much thought to your behavior or reactions.
                </p>
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading2">
            <ng-template ngbPanelTitle>
              <span>
                <span>According to the test results, I have the lowest anxiety index but feel anxious. How
                  is this possible?</span>


              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <p>If you struggle to find the words that adequately explain your anxiety, your
                  condition may be difficult to diagnose using more conventional methods.</p>
                <p>Your low score on the AAB test suggests that your anxiety is situational rather than
                  based on your sensitivity to threatening stimuli.</p>
                <p>The “technical sensitivity” of the Anima test requires that you strictly adhere to
                  the technical rules of the test. Otherwise, it is possible to get inaccurate
                  results.</p>
                <p>If you believe that you did not take the test correctly, try retaking the test and be
                  sure to carefully apply the on-screen suggestions.
                </p>
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading3">
            <ng-template ngbPanelTitle>
              <span>
                <span>I am on medication. Can this affect the test results?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <p>Everything relies on what you consume. The majority of psychoactive substances have
                  an impact on our mental state and response, which will affect the test findings.</p>
                <p>Conversely, antidepressants and anxiolytics strengthen our overall health and
                  self-esteem rather than jeopardize our reactions, which will also have an impact on
                  the outcomes of conventional surveys.</p>
                <p>If your outcomes have improved after taking medication, that’s a fantastic sign!</p>
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading4">
            <ng-template ngbPanelTitle>
              <span>
                <span>Can this test substitute for a visit to a doctor?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <p>Anima is unable to provide a comprehensive diagnosis. It is not possible to get
                  properly diagnosed without first speaking in person with a physician.</p>
                <p>Anima is able to give you the trustworthy information you need in order to make an
                  educated decision about which coping strategies to use or whether you should go see
                  a doctor.</p>
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading5">
            <ng-template ngbPanelTitle>
              <span>
                <span>Previous test results were better than the new ones. Does this mean that my
                  condition is getting worse?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <p>In most cases, no. The anxiety levels that Anima measures are dynamic and may change
                  at any time. A worse result could just mean something is bothering you at the time
                  of the test.</p>
                <p>But let’s say you’ve had a slew of tests that all point to a steady decline in your
                  health while your anxiety symptoms have been increasing in intensity. In this case,
                  we advise that you seek the help of a medical professional, a psychologist, or a
                  psychiatrist.</p>
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading6">
            <ng-template ngbPanelTitle>
              <span>
                <span>Why is my anxiety high? Am I mentally ill?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <p>The human response to danger is anxiety. Anxiety, in particular, triggers the
                  survival instincts that allow us to fight, flee, and save ourselves.</p>
                <p>Yet these defenses can reinforce one another, leading to feelings of anxiety even
                  when there is no actual danger present. A visit to a physician, psychologist, or
                  psychiatrist is advised if you experience severe distress from such a situation for
                  longer than two weeks.</p>
                <p>If you have high anxiety, don’t worry; you are not doomed! 50% of US adults will
                  experience mental health issues at some point n their adult lives, and about 20% of
                  US adults experience mental health problems in any given year. You are definitely
                  not alone if you need to seek treatment.</p>
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel >
            <ng-template ngbPanelTitle>
              <span>
                <span  id="heading7">Is there a way I can improve my results? And do I need my results to be
                  “better”?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <p>The number of elements that contribute to one’s level of anxiety is directly
                  proportional to their level of anxiety.</p>
                <p>If having a higher-than-average anxiety index feels like your normal condition, then
                  it is not necessary for you to make any changes.</p>
                <p>In the event that anxiety is making your life more challenging, the findings of the
                  test will give recommendations on how to reduce the severity of your symptoms.</p>
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading8">
            <ng-template ngbPanelTitle>
              <span>
                <span>The AAB test does not work. How do you fix this?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <p>The test depends on several important parameters:</p>
                <ol>
                  <li>The test can only be taken on a laptop or PC; it is not designed for use on a
                    tablet or smartphone.
                  </li>
                  <li>In order to use an external camera, your device must already have one built
                    in.
                  </li>
                  <li>The website will need access to your camera.</li>
                  <li>The Google Chrome web browser is recommended.</li>
                  <li>If you have an eye condition (eye trauma, keratoconus, pathological nystagmus,
                    etc.), it can impact the test significantly.
                  </li>
                  <li>There could have been an error during the calibration process. Try the test
                    again.
                  </li>
                  <li>If the page lags or loads too slowly, try checking the quality of the Internet
                    connection, or restart your device.
                  </li>
                  <li>The camera must be positioned 12 to 24 inches from your pupils (you should be
                    able to see them on the screen), and it must be able to capture your face fully.
                    Place the camera at or below eye level.
                  </li>
                  <li>Your face must be properly lighted. Change your position if it’s not.</li>
                  <li>If you are wearing glasses, make sure there is no glare from lighting
                    obstructing the camera’s view of your eyes. Sometimes, lenses have in-built
                    filters that reflect light from a screen or lamp, which might prevent the system
                    from recognizing your eye movements. If this is the case, try changing the
                    screen or camera position to avoid glare reflecting on your pupils.
                  </li>
                  <li>There must be no other faces or face images in the frame.</li>
                </ol>
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading9">
            <ng-template ngbPanelTitle>
              <span>
                <span>Is there something I can do during the eye-tracking procedure to ensure a credible
                  result?</span>

              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                <ol>
                  <li>Make sure you are positioned firmly during the test (your chair or the surface
                    your gadget is placed on should remain still). If there is visible vibration or
                    movement on camera, try changing your location.
                  </li>
                  <li>Once the test starts, try not to change your head and body position.</li>
                  <li>Look for a place with stable lighting that covers your face evenly and won’t
                    change during the test.
                  </li>
                </ol>
              </span>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>

      </div>
    </div>
  </div>
</section>

